// extracted by mini-css-extract-plugin
export default {"root":"ycufWTNfBk_GsciIIGPp","main":"hAf6YxIClwzfyWVxIzZG"};